export class Translation {
  public culture: string;
  public key: string;
  public value: string;

  constructor(init?: Partial<Translation>) {
    Object.assign(this, init);
  }
}
